import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  SubmitCreditCardAndEFTPaymentRequest,
  SubmitCreditCardPaymentRequest,
  SubmitEFTPaymentRequest,
  SubmitInvoicePaymentRequest,
  SubmitOfflinePaymentRequest,
  SubmitPaymentResponse,
  SubmitRequest,
  SubmitResponse
} from "../interfaces/form-model";

@Injectable({
  providedIn: 'root'
})
export class FormSubmitService {

  constructor(private http: HttpClient) { }

  submit(request: SubmitRequest): Observable<SubmitResponse> {
    return this.http.post<SubmitResponse>(`${window.location.origin}/ui-forms/v1/form/submission`, request);
  }

  submitCreditCardPayment(request: SubmitCreditCardPaymentRequest): Observable<SubmitPaymentResponse> {
    return this.http.post<SubmitPaymentResponse>(`${window.location.origin}/ui-forms/v1/form/submission`, request);
  }

  submitEFTPayment(request: SubmitEFTPaymentRequest): Observable<SubmitPaymentResponse> {
    return this.http.post<SubmitPaymentResponse>(`${window.location.origin}/ui-forms/v1/form/submission`, request);
  }

  submitCreditCardAndEFTPayment(request: SubmitCreditCardAndEFTPaymentRequest): Observable<SubmitPaymentResponse> {
    return this.http.post<SubmitPaymentResponse>(`${window.location.origin}/ui-forms/v1/form/submission`, request);
  }

  submitOfflinePayment(request: SubmitOfflinePaymentRequest): Observable<SubmitPaymentResponse> {
    return this.http.post<SubmitPaymentResponse>(`${window.location.origin}/ui-forms/v1/form/submission`, request);
  }

  submitInvoicePayment(request: SubmitInvoicePaymentRequest): Observable<SubmitPaymentResponse> {
    return this.http.post<SubmitPaymentResponse>(`${window.location.origin}/ui-forms/v1/form/submission`, request);
  }
}
